import genZIndexValues from './genZIndexValues';

export const zIndexValues = genZIndexValues(
  'stickyToolbar',
  'documentsTableProgress',
  'priceAssistant',
  'navbar',
  'stickyHeader',
  'promptBar',
  'getStartedButton',
  ['intercom', 2147483001],
  'modalOverlayInactive',
  'modalInactive',
  'modalOverlay',
  'modal',
  'modalCloseIcon',
  'lightbox',
  'overlayBackground',
  'autocompleteSuggestions',
  'topLevelModalOverlay',
  'topLevelModal',
  'draggedTableRow',
  'popover',
  'overlayElement',
  'toast',
  'appOutdatedNotification',
  'dragMask',
  'loadingOverlay',
);
